import request from "@/utils/request";

export function GetIndustrys(nameInfo){
    return request({   
    url:`/industry/getindustrys?name=${nameInfo}`,
    method: 'get',
  })
}

export function OperateIndustry(industryInfo) {
  const data = {
    'content' :
    [
        {
            'id': industryInfo.id,
            'createBy': industryInfo.createBy,
            'createDate': industryInfo.createDate,            
            'name': industryInfo.name,
            'description': industryInfo.description
        }
    ],
    'operate': industryInfo.operate 
  };
  //console.log(data);
  return request({
    url: "/industry/operateindustry", 
    method: "post",
    data,
  });
}

export function GetIndustrySolutions(formInf) {
  const data = {
    id: formInf.id,
    name: formInf.name,
    industryId: formInf.industryID,
  }; 
  // console.log(data);
  return request({
    url: "/industrySolution/getindustrysolutions",
    method: "post",
    data,
  });
}

export function OperateIndustrySolution(formData) {  
  return request({
    url: '/industrysolution/operateIndustrysolution', 
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data' // 重要：必须设置这个请求头
    }
  })
}

export function Downloadfile(formData) { 
  const data = {
    filePath: formData,    
  }; 
  return request({
    url: "/industrySolution/downloadfile",
    method: "post",
    data,
  });
}
